<template>
  <div class="container-static">
    <div class="form-container">
      <SiteLogo/>
      <div v-if="loader || regRulesAndTermsLoader" class="group-data-loader">
        <spinner/>
      </div>
      <div v-else-if="isValidConfirmationData">
        <RegistrationFormFull
          :regRulesAndTerms="regRulesAndTerms"
          :email="email"
          :userId="userId"
          :verifyingCode="verifyingCode"
          :registrationCode="registrationCode"
        />
      </div>
      <div v-else>
        <h2 class="text-center">Подтвреждение регистрации</h2>
        <div class="nav-links">
          <a class="link" href="/login">Войти</a>
          <a class="link" href="/register">Зарегистрироваться</a>
        </div>
        <ErrorAlert :message="errorMsg" />
        <!-- <div class="text-center">{{errorMsg}}</div> -->
        <div class="link-tabs">
          <button class="link main-page-link" @click="gotoMainPage">вернуться на главную</button>
          <!-- <button class="btn blue align-center" @click="gotoMainPage">вернуться на главную</button> -->
        </div>
      </div>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import RegistrationFormFull from '@/components/IdentityForms/RegistrationFormFull.vue';

export default {
  components: {
    RegistrationFormFull
  },
  data: function () {
    return {
      loader: true,
      regRulesAndTermsLoader: true,
      // userRegRulesAndTermsLoader: true,
      regRulesAndTerms: null,
      isValidConfirmationData: false,
      errorMsg: '',
      email: '',
      userId: '',
      verifyingCode: '',
      registrationCode: ''
    }
  },
  computed: {
    title() { return document.title; }
  },
  methods: {
    gotoMainPage() {
      this.$store.dispatch('setGuest', false);
      window.location.href = '/';
    },
    loadUserRegRulesAndTerms() {
      this.regRulesAndTermsLoader = true;
      this.$http.get(`${this.$host.IdentityServiceApi}/UserRegRulesAndTerms`)
      .then((response) => {
        this.regRulesAndTerms = response.body;
        this.regRulesAndTermsLoader = false;
      })
      .catch(() => {
        this.regRulesAndTerms = null;
        this.regRulesAndTermsLoader = false;
      })
    },
    checkConfirmation() {
      this.loader = true;
      this.errorMsg = '';
      this.isValidConfirmationData = false;
      this.userId = this.$route.query.userId; 
      this.email = this.$route.query.email;
      this.verifyingCode = this.$route.query.code;
      if (!this.userId || !this.userId.length || !this.email || !this.email.length || !this.verifyingCode || !this.verifyingCode.length) {
        this.isInvalidConfirmationData = true;
        window.location.href = '/';
        return;
      }
      const payload = {
        userId: this.userId,
        email: this.email,
        verifyingCode: this.verifyingCode
      }
      this.$http.post(`${this.$host.IdentityServiceApi}/ConfirmEmailRegistration`, payload)
      .then((response) => {
        this.isValidConfirmationData = true;
        this.loader = false;
      })
      .catch((e) => {
        if (e.message && e.message.length) this.errorMsg = e.message;
        if (e.body && e.body.message && e.body.message.length) this.errorMsg = e.body.message;
        else this.errorMsg = 'Ошибка. Недействительные данные';
        this.loader = false;
      });
    }
  },
  created() {
    this.loadUserRegRulesAndTerms();
    this.checkConfirmation();
  }
}
</script>

<style scoped>
.nav-links {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.form-container {
  margin-top: 10svh;

  min-width: 30rem;
  width: 30rem;
  max-width: calc(100% - 2rem);
  margin-left: auto;
  margin-right: auto;
  padding: 1rem;
}
.text-center {
  text-align: center;
}
.main-page-link {
  margin-top: 2.5rem;
  margin-left: auto;
  margin-right: auto;
  display: table;
  margin-bottom: 1rem;
}
@media screen and (orientation:landscape)
and (min-device-height: 319px) 
and (max-device-height: 480px) {
  .form-container {
    margin-top: 0;
  }
}
@media only screen and (max-width: 800px) {
  .form-container {
    min-width: auto;
    width: auto;
    max-width: calc(30rem);
  }
}
</style>